import * as z from "zod/v4";

export const unmergeFulfillmentOrdersFromGroups = {
  name: "unmergeFulfillmentOrdersFromGroups" as const,
  input: z.object({
    unmergeRequests: z.array(
      z.object({
        fulfillmentGroupId: z.string(),
        fulfillmentOrderIdsToUnmerge: z.array(z.string()),
      }),
    ),
  }),
  output: z.void(),
};
